import request from '@/utils/request.js'
// 请求用户分配专业id
export function getUserFid(params) {
    return request({
      url: '/index/index/getUserNavList',
      methods: 'get',
      params
    })
  }
